import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import { StrictMode } from 'react';

import { createRoot } from 'react-dom/client';

import { loadAppConfig } from './config/appConfig';
import './index.css';
import ThemeProvider from './themes/ThemeProvider';

const initApp = async () => {
    await loadAppConfig();

    const { App } = await import('./App');

    const container = document.getElementById('root');
    const root = createRoot(container!);

    root.render(
        <StrictMode>
            <ThemeProvider>
                <App />
            </ThemeProvider>
        </StrictMode>
    );
};

initApp();
